import LogoutIcon from './LogoutIcon';

export default LogoutIcon;
